<lh-navigation-layout-page [sourceItem]="page" [showLoadingIndicator]="showLoadingIndicator">
    <vn-cashier-iframe [page]="page" cssClass="cashier-iframe-wrapper" (onLoaded)="hideLoadingIndicator()" />
</lh-navigation-layout-page>
